<template>
  <div class="flight-bags">
    <content-section>
      <template>
        <flight-pad-details-bags
          :flight_offer="flight_offer"
          :title="title"
          :description="description"
        />
      </template>
    </content-section>
  </div>
</template>

<script>
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";
import FlightPadDetailsBags from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details-bags.vue";

export default {
  name: "flight-bags",

  components: {
    "content-section": ContentSection,
    "flight-pad-details-bags": FlightPadDetailsBags,
  },

  props: {
    flight_offer: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      // copy della sezione bagagli specifico del checkout
      title: "Bagagli inclusi nella tariffa",
      description: `I bagagli indicati si riferiscono a ciascun passeggero adulto. Controlla sempre peso, misure e condizioni sul sito della compagnia. Questo box non mostra eventuali bagagli in stiva aggiunti (vedi box Bagagli extra).<br/> Se hai una <strong class="semibold">tariffa con bagaglio a mano</strong>, alcuni dettagli potrebbero essere visibili solo accedendo alla prenotazione sul sito della compagnia.`,
    };
  },
};
</script>

<style lang="scss" scoped>

  ::v-deep {
    .flight-pad-details-bags {

      &__description {
        font-size: $font-size-md;
      }
      padding: 0;
    }
  }
</style>
